import { RequestDescriptor } from './Authorizer';
const crypto = require('crypto');
export class SigV4RequestDescriptor extends RequestDescriptor {
    constructor(credentials, method, host, endpoint, queryString, data, service, region) {
        super(credentials);
        this.method = method;
        this.host = host;
        this.endpoint = endpoint;
        this.queryString = queryString;
        this.data = data;
        this.service = service;
        this.region = region;
    }
}
/**
* @class
* @name SigV4Crendentials
* @description SIGV4 Credentials
**/
export class SigV4Crendentials {
    constructor(sessionToken, secretKey, accessKey) {
        this.sessionToken = sessionToken;
        this.secretKey = secretKey;
        this.accessKey = accessKey;
    }
}
/**
* @class
* @name SigV4
* @description SIGV4 Authorizer
**/
export class SigV4Authorizer {
    constructor(serviceName, region) {
        this.serviceName = serviceName;
        this.region = region;
    }
    authorize(requestDescriptor, asQueryString = false) {
        if (!asQueryString) {
            return this.signAsHeaders(requestDescriptor.method, requestDescriptor.host, requestDescriptor.endpoint, requestDescriptor.queryString, requestDescriptor.data, requestDescriptor.service, requestDescriptor.region, requestDescriptor.credentials.accessKey, requestDescriptor.credentials.secretKey, requestDescriptor.credentials.sessionToken);
        }
        else {
            return this.signAsQueryString(requestDescriptor.method, requestDescriptor.host, requestDescriptor.endpoint, requestDescriptor.data, requestDescriptor.service, requestDescriptor.region, requestDescriptor.credentials.accessKey, requestDescriptor.credentials.secretKey, requestDescriptor.credentials.sessionToken);
        }
    }
    /**
     * @method SignAsHeaders Generates request sign as headers
     * @param {string} apiMethod HTTP method
     * @param {string} apiHost Host
     * @param {string} apiEndpoint Path
     * @param {string} apiQueryString Query string
     * @param {any} data Body
     * @param {string} service Service name (e.g. 'iotdevicegateway')
     * @param {string} region Region service (e.g. 'us-east-1')
     * @param {string} accessKey Credentials access key id
     * @param {string} secretKey Credentials secret key
     * @param {string} sessionToken Credentials session token
    */
    signAsHeaders(apiMethod, apiHost, apiEndpoint, apiQueryString, data, service, region, accessKey, secretKey, sessionToken) {
        var serviceName = service;
        var now = new Date();
        var amzdate = now.toJSON().replace(/[-:]/g, "").replace(/\.[0-9]*/, "");
        var datestamp = now.toJSON().replace(/-/g, "").replace(/T.*/, "");
        var apiEndpointEncoded = apiEndpoint.replace(/[:]/g, function (c) {
            return ('%' + c.charCodeAt(0).toString(16)).toUpperCase();
        });
        var apiQueryStringEncoded = apiQueryString.replace(/[:]/g, function (c) {
            return ('%' + c.charCodeAt(0).toString(16)).toUpperCase();
        });
        var payloadHash = crypto.createHash('sha256').update(data).digest('hex');
        var canonicalHeaders = "host:" + apiHost + "\nx-amz-date:" + amzdate +
            "\nx-amz-security-token:" + sessionToken + "\n";
        var signedHeaders = "host;x-amz-date;x-amz-security-token";
        var canonicalRequest = apiMethod + "\n" + apiEndpointEncoded + "\n" + apiQueryStringEncoded +
            "\n" + canonicalHeaders + "\n" + signedHeaders + "\n" + payloadHash;
        // ************* TASK 2: CREATE THE STRING TO SIGN*************
        // Match the algorithm to the hashing algorithm you use, either SHA-1 or
        // SHA-256 (recommended)
        var algorithm = 'AWS4-HMAC-SHA256';
        var credentialScope = datestamp + '/' + region + '/' + serviceName + '/' + 'aws4_request';
        var stringToSign = algorithm + '\n' + amzdate + '\n' + credentialScope + '\n' +
            crypto.createHash('sha256').update(canonicalRequest).digest('hex');
        // ************* TASK 3: CALCULATE THE SIGNATURE *************
        // Create the signing key using the function defined above.
        var signingKey = getSignatureKey(secretKey, datestamp, region, serviceName);
        var signature = crypto.createHmac('sha256', signingKey).update(stringToSign).digest('hex');
        // ************* TASK 4: ADD SIGNING INFORMATION TO THE REQUEST *************
        // The signing information can be either in a query string value or in
        // a header named Authorization. This code shows how to use a header.
        // Create authorization header and add to request headers
        var authorizationHeader = algorithm + ' ' + 'Credential=' + accessKey + '/' + credentialScope +
            ', ' + 'SignedHeaders=' + signedHeaders + ', ' + 'Signature=' + signature;
        return {
            'X-Amz-Security-Token': sessionToken,
            'X-Amz-Date': amzdate,
            'Authorization': authorizationHeader
        };
    }
    /**
     * @method SignAsQueryString Generates generic request sign as query string (without custom query string)
     * @param {string} apiMethod Method (e.g. 'GET')
     * @param {string} apiHost Method (e.g. 'xxx.iot.us-east-1...')
     * @param {string} apiEndpoint Path (e.g. '/mqtt')
     * @param {any} data Body (e.g. '')
     * @param {string} apiService Service name (e.g. 'iotdevicegateway')
     * @param {string} region Region service (e.g. 'us-east-1')
     * @param {string} accessKey Credentials access key id
     * @param {string} secretKey Credentials secret key
     * @param {string} sessionToken Credentials session token
    */
    signAsQueryString(apiMethod, apiHost, apiEndpoint, data, apiService, region, accessKeyId, secretAccessKey, sessionToken) {
        //var datetime = AWS.util.date.iso8601(new Date()).replace(/[:\-]|\.\d{3}/g, '');
        var datetime = (new Date()).toISOString().replace(/[:-]|\.\d{3}/g, '');
        var date = datetime.substr(0, 8);
        var method = apiMethod; //'GET';
        // var protocol = apiProtocol//'wss';
        var uri = apiEndpoint; //'/mqtt';
        var service = apiService; //'iotdevicegateway';
        var algorithm = 'AWS4-HMAC-SHA256';
        var host = apiHost;
        var credentialScope = date + '/' + region + '/' + service + '/' + 'aws4_request';
        var canonicalQuerystring = 'X-Amz-Algorithm=' + algorithm;
        canonicalQuerystring += '&X-Amz-Credential=' + encodeURIComponent(accessKeyId + '/' + credentialScope);
        canonicalQuerystring += '&X-Amz-Date=' + datetime;
        canonicalQuerystring += '&X-Amz-SignedHeaders=host';
        var canonicalHeaders = 'host:' + host + '\n';
        var payloadHash = crypto.createHash('sha256').update(data).digest('hex');
        var canonicalRequest = method + '\n' + uri + '\n' + canonicalQuerystring + '\n' + canonicalHeaders + '\nhost\n' + payloadHash;
        var stringToSign = algorithm + '\n' + datetime + '\n' + credentialScope + '\n' + crypto.createHash('sha256').update(canonicalRequest).digest('hex');
        // var signingKey = SigV4Utils.getSignatureKey(secretAccessKey, date, region, service)
        // var signature = AWS.util.crypto.hmac(signingKey, stringToSign, 'hex')
        var signingKey = getSignatureKey(secretAccessKey, date, region, service);
        var signature = crypto.createHmac('sha256', signingKey).update(stringToSign).digest('hex');
        canonicalQuerystring += '&X-Amz-Signature=' + signature;
        if (sessionToken) {
            canonicalQuerystring += '&X-Amz-Security-Token=' + encodeURIComponent(sessionToken);
        }
        return canonicalQuerystring;
    }
}
function getSignatureKey(key, date, region, service) {
    // var kDate = AWS.util.crypto.hmac('AWS4' + key, date, 'buffer')
    // var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer')
    // var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer')
    // var kCredentials = AWS.util.crypto.hmac(kService, 'aws4_request', 'buffer')
    var kDate = Buffer.from(crypto.createHmac('sha256', 'AWS4' + key).update(date).digest('hex'), "hex");
    var kRegion = Buffer.from(crypto.createHmac('sha256', kDate).update(region).digest('hex'), "hex");
    var kService = Buffer.from(crypto.createHmac('sha256', kRegion).update(service).digest('hex'), "hex");
    var kCredentials = Buffer.from(crypto.createHmac('sha256', kService).update('aws4_request').digest('hex'), "hex");
    return kCredentials;
}
//# sourceMappingURL=Sigv4Authorizer.js.map